const DEFAULT_SYNC_HEADERS = {
  Accept: "application/json",
};

export default DEFAULT_SYNC_HEADERS;
